import { API, deleteRequest, getRequest, postRequest, putRequest } from '@/api/api.ts';

import type {
  CreateVendorMappingBody,
  UpdateVendorMappingBody,
  VendorMapping,
} from './transactions.dto.ts';

const VENDOR_MAPPING_PATH = '/card-import/vendor-mapping';

export const getVendorMappings = async () => {
  const response = await getRequest<VendorMapping[]>(API.EXPENSES, VENDOR_MAPPING_PATH);
  return response.data || [];
};

export const createVendorMapping = async (body: CreateVendorMappingBody) => {
  const response = await postRequest<VendorMapping, CreateVendorMappingBody>(
    API.EXPENSES,
    VENDOR_MAPPING_PATH,
    body,
  );
  return response.data;
};

export const updateVendorMapping = async (id: string, body: UpdateVendorMappingBody) => {
  const response = await putRequest<VendorMapping, UpdateVendorMappingBody>(
    API.EXPENSES,
    `${VENDOR_MAPPING_PATH}/${id}`,
    body,
  );
  return response.data;
};

export const removeVendorMapping = async (id: string) => {
  await deleteRequest(API.EXPENSES, `${VENDOR_MAPPING_PATH}/${id}`);
};
